var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hover",class:{ area: _vm.area },on:{"click":function($event){return _vm.$emit('click', true)}}},[_c('div',{staticClass:"ac-button",class:{ large: _vm.large }},[_vm._t("default")],2)]),(_vm.quantity > 0)?_c('div',{staticClass:"circle"},[_vm._v(_vm._s(_vm.quantity))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }